module.exports = __webpack_public_path__ + "banquet/components/InventoryRecordListElement/images/button_heart.0456b4a5342bc8b77c3d3de965e48393.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/InventoryRecordListElement/images/button_heart.png
// module id = 1676
// module chunks = 1